import React from 'react';
import { FaArrowLeft, FaLongArrowAltLeft, FaLongArrowAltRight, FaPhotoVideo, FaRegWindowMaximize } from 'react-icons/fa';
import { peerlessDataForBrandAndId} from '../Components/PeerlessData';
import Slider from 'react-slick';
import { Tooltip } from 'react-tooltip';

const GraphicDesignPage3 = ({setNavLinks, handleImageExpansion, slidesToShow1, setSlidesToShow1, sliderState11, setSliderState11, handleAfterChange11}) => {


    
  React.useEffect(() => {
    // retrieve slider state from local storage on component mount
    const storedState = JSON.parse(sessionStorage.getItem('sliderState11'));
    if(storedState){setSliderState11(storedState)}
    const handleResize = () => {
      if (window.innerWidth >= 1030) {
        setSlidesToShow1(6);
      } else if (window.innerWidth >= 600) {
        setSlidesToShow1(5);
      } else if (window.innerWidth >= 300) {
        setSlidesToShow1(2);
      } else {
        setSlidesToShow1(1);
      }

      
    };

    handleResize()
    window.addEventListener('resize', handleResize);
    
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [setSlidesToShow1, setSliderState11]);

    const settings = {

        dots: false,
        Infinity: true,
        slidesToShow: slidesToShow1,
        slidesToScroll: 1,
        lazyLoad: true,
        Speed: 200,
        swipe: true,
        swipeToSlide: true,

       
    }


  return (
    <div className='container-fluid'> 
            <div className='close-window-icon' ><FaArrowLeft color='#1b2328' onClick={()=>{
              
              setNavLinks({serviceLink: true})
              sessionStorage.setItem("currentSession", JSON.stringify({serviceLink: true}));
              }}/> </div>
            <h1 className='title'><FaPhotoVideo color='#1b2328' /> Branding & Identity Cards </h1>



             {/* Graphic Design for Branding and Identity Cards */}
        <div className="hair-service-container">

                <h1>Slide to see more <FaLongArrowAltRight/></h1>

                <Slider {...settings} afterChange={handleAfterChange11} initialSlide={sliderState11.currentSlide}>

                        {

                        peerlessDataForBrandAndId.map((ourHair)=>{

                            return(
                                    <article className='hair-service-card' key={ourHair.id} > 
                                            
                                            <div className="hair-service-img-container">
                                            <img src={require(`../Images/ServiceImages/${ourHair.folder}/${ourHair.image}`)} alt="Hair Styles"/>
                                            </div>

                                            <div className="hair-service-details">

                                                <p>{ourHair.name} </p>

                                                
                                            </div>

                                            <div className='enlarge-img-icon' data-tooltip-id='my-tooltip' data-tooltip-content='Expand'><Tooltip id='my-tooltip'/><FaRegWindowMaximize onClick={()=>handleImageExpansion(ourHair.id)} color='white'/></div>
                                            

                                    </article>
                            )

                        })
                        }

                </Slider>
        </div>

            
                <div className='see-more' onClick={()=>{
                  
                  setNavLinks({graphicDesignLink2: true})
                  sessionStorage.setItem("currentSession", JSON.stringify({graphicDesignLink2: true}));
                  }}>
                    
                    <p> <FaLongArrowAltLeft/> Go Back </p>
                
                </div>
    
    </div>
  )
}

export default GraphicDesignPage3;